module.exports = __webpack_public_path__ + "static/media/arrow-right-long-blue.ca06c6de.svg";